import clsx from "clsx";
import Flex from "components/Flex";
import { node, string } from "prop-types";

import classes from "./RequirementChip.module.scss";

const RequirementChip = ({ value, className, icon }) => (
  <Flex className={clsx(classes["requirement_chip"], className)}>
    {icon}
    {value}
  </Flex>
);

RequirementChip.propTypes = {
  className: string,
  icon: node,
  value: node,
};

export default RequirementChip;
